import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums, EnumListKey } from '~/data/enums';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/components/FormComponent/components/Common/useStyles';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';

type Props = {
  control: Control<Form>;
  errors: FieldErrors<Form>;
  getValues: UseFormGetValues<Form>;
  allEnums: AllEnums;
  index: number;
  setValue: UseFormSetValue<Form>;
};

export const InternalPositionComponent = ({
  control,
  getValues,
  allEnums,
  errors,
  index,
  setValue,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');

  const {
    filterActiveEnumsByFormSelections,
    currentFieldValue: { fEmpLegalEntityValue },
  } = useFilterActiveEnumsByFormSelections({
    control,
    index,
    getValues,
  });

  const filteredOptions = filterActiveEnumsByFormSelections(
    allEnums[EnumListKey.EMPLOYEE_POSITION],
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.empPosition.fInternalPositionPosition`}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          required
          sx={sxStyles.selectStyle}
          placeholder={t('laSelectFirstLegEnt')}
          disabled={fEmpLegalEntityValue === ''}
          options={filteredOptions}
          getOptionLabel={(c) => c?.name || ''}
          onChange={(e, value) => {
            onChange(value?.code || '');
          }}
          value={filteredOptions.find((ep) => ep?.code === value) || null}
          label={t('laPosition')}
          fieldError={
            errors.schedule?.[index]?.empPosition?.fInternalPositionPosition
          }
        />
      )}
    />
  );
};
